"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

exports.default = _Dropdown.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/modules/Dropdown/index.js
// module id = 217
// module chunks = 0